import React from 'react';

import {
  Box,
  Typography
} from '@mui/material';

const TILE_LABEL_COLOR = 'rgba(226, 242, 249, 0.6)';

// Accents that read well on the app's dark surfaces. Same palette the demo
// analytics and error log pages already use, so the tiles look like one system.
export const TILE_ACCENT = {
  neutral: '#e2f2f9',
  good: '#4ade80',
  warn: '#fbbf24',
  bad: '#f87171',
  info: '#60a5fa',
};

/**
 * Row of headline counters shown above a table.
 *
 * @param {Array} tiles - [{ label, value, accent, onClick }] where accent is a
 *                        hex string (use TILE_ACCENT for the shared palette).
 *                        A tile with `onClick` renders as clickable.
 */
const SummaryTiles = ({ tiles }) => {
  if (!tiles || tiles.length === 0) return null;

  return (
    <Box
      display={"flex"}
      flexWrap={"wrap"}
      gap={"12px"}
      mb={"14px"}>
      {
        tiles.map((tile, index) => (
          <Box
            key={index}
            onClick={tile.onClick}
            sx={{
              flex: "1 1 140px",
              minWidth: "140px",
              border: `1px solid ${tile.accent}40`,
              background: `${tile.accent}14`,
              borderRadius: "12px",
              padding: "14px 16px",
              transition: "all .15s",
              cursor: tile.onClick ? "pointer" : "default",
              "&:hover": tile.onClick
                ? { background: `${tile.accent}24`, borderColor: `${tile.accent}80` }
                : {},
            }}>
            <Typography
              sx={{ fontSize: "26px", fontWeight: 700, lineHeight: 1.1, color: tile.accent }}>
              {tile.value}
            </Typography>
            <Typography
              variant='caption'
              sx={{ color: TILE_LABEL_COLOR }}>
              {tile.label}
            </Typography>
          </Box>
        ))
      }
    </Box>
  )
}

export default SummaryTiles;
